import stickman from "../../assets/images/stickman.jpg";
// import stickman from "../../assets/images/stickman-no-bkgd.png";
import "./MidHome.scss";
import { Link } from "react-router-dom";

function MidHome() {
  return (
    <section className="home-mid">
      <div className="home-mid__content">
        <h3 className="home-mid__title">Hope Might Be Closer Than You Think</h3>

        <p className="home-mid__paragraph">
          UnGriefMe is a site created to help those who are grieving.
        </p>
        <p className="home-mid__paragraph">
          This place of peace, love and support was created to lift your spirit
          and to help you get through.
        </p>
      </div>
      <div className="home-mid__stickman">
        <img className="home-mid__stickman-img" src={stickman} alt="stickman" />
        <Link to={"/stories"}>
          <button className="home-mid__stickman-btn">Share Your Story</button>
        </Link>
      </div>
    </section>
  );
}
export default MidHome;
